module.exports = __webpack_public_path__ + "static/media/creditPage2.68787bc7.png";